(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ep-bulk-offer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epBulkOfferInit) return;
    window.__epBulkOfferInit = true;

    var PLUS = '<span class="ep-offer__add-icon" aria-hidden="true"><svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></span><span class="ep-offer__add-label">Toevoegen</span>';
    var SPIN = '<span class="ep-offer__spinner"></span>';
    var CHECK = '<span class="ep-offer__add-icon" aria-hidden="true"><svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"><polyline points="20 6 9 17 4 12"/></svg></span><span class="ep-offer__add-label">Toegevoegd</span>';

    async function addToCart(btn) {
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      var original = btn.innerHTML;
      btn.classList.add('is-loading');
      btn.innerHTML = SPIN;
      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var cartComp = document.querySelector('cart-items-component[data-drawer]');
        var sectionId = cartComp ? cartComp.dataset.sectionId : null;
        var qty = Number(btn.dataset.qty) || 1;
        var body = { id: Number(variantId), quantity: qty };
        if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('cart/add ' + res.status);
        var cartData = await res.json();
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.innerHTML = CHECK;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cartData, sourceId: 'ep-bulk-offer', data: { itemCount: cartData.cart_count || 0, source: 'ep-bulk-offer', sections: cartData.sections || {} } }
        }));
        if (sectionId && cartData.sections && cartData.sections[sectionId] && cartComp) {
          var doc = new DOMParser().parseFromString(cartData.sections[sectionId], 'text/html');
          var newComp = doc.querySelector('cart-items-component[data-drawer]');
          if (newComp) cartComp.innerHTML = newComp.innerHTML;
        }
        setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = original; }, 2500);
      } catch (err) {
        console.error('[ep-bulk-offer] add error:', err);
        btn.classList.remove('is-loading');
        btn.innerHTML = original;
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ep-offer__add[data-variant-id]');
      if (btn) { e.preventDefault(); addToCart(btn); }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-buybox-options"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epBuyboxInit) return;
    window.__epBuyboxInit = true;

    function nativeRadios() {
      var picker = document.querySelector('variant-picker, .variant-picker');
      return picker ? picker.querySelectorAll('input[type="radio"]') : [];
    }
    function sync() {
      var checked = null;
      nativeRadios().forEach(function (r) { if (r.checked) checked = r.value; });
      document.querySelectorAll('.ep-buybox__card').forEach(function (c) {
        c.classList.toggle('is-selected', c.dataset.value === checked);
      });
    }
    function select(val) {
      var target = null;
      nativeRadios().forEach(function (r) { if (r.value === val) target = r; });
      if (target && !target.checked) {
        target.click();
        setTimeout(sync, 40);
      }
    }
    function applyDefault() {
      var box = document.querySelector('.ep-buybox[data-default]');
      if (!box) return;
      var def = box.getAttribute('data-default');
      if (!def) return;
      // Respect an explicit variant in the URL; only force the default otherwise.
      if (/[?&]variant=/.test(location.search)) return;
      var checked = null;
      nativeRadios().forEach(function (r) { if (r.checked) checked = r.value; });
      if (checked !== def) select(def);
    }
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.ep-buybox__card');
      if (card && !card.disabled) { e.preventDefault(); select(card.dataset.value); }
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('variant-picker input, .variant-picker input')) sync();
    });
    function init() { sync(); applyDefault(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    setTimeout(applyDefault, 300);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-qty-deal"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epQtyDealInit) return;
    window.__epQtyDealInit = true;

    function form() {
      return document.querySelector('product-form-component');
    }

    function applyQty(n) {
      var scope = form();
      if (!scope) return;

      // Publieke API van quantity-selector-component heeft voorrang: die houdt
      // interne state en min/max-regels bij. De input-fallback dekt het geval
      // waarin het component (nog) niet geupgraded is.
      var comp = scope.querySelector('quantity-selector-component');
      if (comp && typeof comp.setValue === 'function') {
        try { comp.setValue(n); } catch (e) {}
      }

      var input = scope.querySelector('input[name="quantity"]');
      if (input && input.value !== String(n)) {
        input.value = String(n);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function select(card) {
      var box = card.closest('.ep-qtydeal');
      if (!box) return;
      box.querySelectorAll('.ep-qtydeal__card').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyQty(parseInt(card.dataset.qty, 10) || 1);
    }

    function init() {
      document.querySelectorAll('.ep-qtydeal').forEach(function (box) {
        var want = box.getAttribute('data-default');
        var cards = box.querySelectorAll('.ep-qtydeal__card');
        if (!cards.length) return;
        var target = box.querySelector('.ep-qtydeal__card[data-qty="' + want + '"]') || cards[0];
        select(target);
      });
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.ep-qtydeal__card');
      if (card) { e.preventDefault(); select(card); }
    });

    // De theme kan het formulier her-renderen (morph) na een variant-wissel of
    // cart-update; dan moet de gekozen hoeveelheid terug in de input.
    document.addEventListener('variant:update', function () { setTimeout(init, 60); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-size-cards"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epSizeCardsInit) return;
    window.__epSizeCardsInit = true;

    function nativeInput(maat) {
      var picker = document.querySelector('variant-picker');
      if (!picker) return null;
      var inputs = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === maat) return inputs[i];
      }
      return null;
    }

    function select(card, doClick) {
      var box = card.closest('.ep-sizecards');
      if (!box) return;
      box.querySelectorAll('.ep-sizecards__card').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (doClick) {
        var input = nativeInput(card.dataset.maat);
        if (input && !input.checked) input.click();
      }
    }

    function sync() {
      document.querySelectorAll('.ep-sizecards').forEach(function (box) {
        var picker = document.querySelector('variant-picker');
        var gekozen = null;
        if (picker) {
          var checked = picker.querySelector('input[type="radio"]:checked');
          if (checked) gekozen = checked.value;
        }
        var cards = box.querySelectorAll('.ep-sizecards__card:not(.is-uitverkocht)');
        if (!cards.length) return;
        var target = null;
        if (gekozen) target = box.querySelector('.ep-sizecards__card[data-maat="' + gekozen + '"]');
        select(target || cards[0], false);
      });
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.ep-sizecards__card');
      if (card && !card.disabled) { e.preventDefault(); select(card, true); }
    });

    document.addEventListener('variant:update', function () { setTimeout(sync, 60); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
